// ===============================================================
// displayName.js — shared client-side display-name normalization
// path: src/utils/displayName.js
// ===============================================================
// SelectGenderPage.js (onboarding) and EditProfileForm.js (later edits)
// both need to apply the EXACT same rules to the canonical users/{uid}
// .name field - this file exists so those two call sites can never
// drift apart. The server independently enforces the same shape in
// functions/auth/completeOnboarding.js's validateOnboardingName() (see
// that file's header) - this is defense-in-depth, not the only check.

// Matches the existing publicProfiles canonical cap for this field -
// functions/lib/publicProfile.js's cleanString(data.name, 120).
export const NAME_MAX_LENGTH = 120;

/** Trims and collapses repeated internal whitespace into a single space. */
export function normalizeNameInput(raw) {
  return String(raw || "").replace(/\s+/g, " ").trim();
}

/**
 * @param {*} raw
 * @return {{ok: boolean, value: string, errorKey: string|null}} -
 *   errorKey is one of the existing gender.* onboarding translation
 *   keys ("gender.name_required" / "gender.name_too_long"), reused
 *   here deliberately so no untranslated string is ever introduced.
 */
export function validateDisplayName(raw) {
  const normalized = normalizeNameInput(raw);
  if (!normalized) {
    return { ok: false, value: "", errorKey: "gender.name_required" };
  }
  if (normalized.length > NAME_MAX_LENGTH) {
    return { ok: false, value: normalized, errorKey: "gender.name_too_long" };
  }
  return { ok: true, value: normalized, errorKey: null };
}
